import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { JoinBattleInput, JoinBattleOutput } from "types/web-app";

export const joinBattle = async (
  accessToken: string,
  input: JoinBattleInput,
) => {
  const endpoint =
    input.battle_type === "single" ? "/join-battle" : "/join-group-battle";

  const response = await fetchWithAuth(endpoint, accessToken, {
    method: "POST",
    body: JSON.stringify(input),
  });
  const data = (await response.json()) as ServiceResponse<JoinBattleOutput>;
  return data;
};
